import '@/globals';
import Faq from '@components/Faq';

const faq = new Faq();
faq.init();

